import styles from './ProgressDashLine.module.less'


interface Props {
  x: number
  visible?: boolean
  videoSize: { width: string, height: string, left: string, top: string }
  linePosition: { height: number, top: number }
}
function ProgressDashLine(props: Props) {
  const {
    height, top,
  } = props.videoSize

  return <div className={styles.progressDashLine}
    style={{
      display: props.visible ? 'block' : 'none',
      height,
      top,
      transform: `translateX(${props.x}px)`
    }}></div>
}

export default ProgressDashLine
